import React from 'react';
import Button from '@mui/material/Button';

export default function ContactUs() {
  return (
    <>
      <div className='bg-[#f3f8f3]'>
        
        {/* Banner Section */}
        <div className='md:h-[80vh] h-[60vh] relative'>
          <h2 className='bg-transparent pt-72 z-30 absolute text-white md:pl-48 md:text-8xl text-5xl'>
            Contact Us
          </h2>
          <div className='md:h-[80vh] h-[60vh] bg-black opacity-50 w-full absolute z-20'></div>
          <img
            src='https://images.pexels.com/photos/2039570/pexels-photo-2039570.jpeg'
            alt='Contact Us Banner'
            className='h-full w-full object-cover'
          />
        </div>

        {/* Contact Form Section */}
        <div className='bg-[#f3f8f3] md:px-36 px-4 flex justify-center items-center md:flex-row flex-col'>
          <div>
            <p className='text-green-500 uppercase text-2xl text-shadow-2xl py-12 bg-transparent'>
              Get In Touch
            </p>
            <h3 className='text-6xl font-[500] tracking-wide'>Let’s work together</h3>
            <h3 className='text-5xl uppercase py-12 tracking-wide'>Get in touch</h3>
            <p className='md:w-[50%] opacity-70 text-left text-lg font-[400]'>
              We'd love to hear from you! Whether you have inquiries about our import-export services,
              partnership opportunities, or need assistance with your shipments, our team is here to help.
            </p>

            <div className='md:px-16 py-6'>
              <p className='uppercase font-[600] text-[18px]'>Office Address</p>
              <p className='opacity-80 py-3 font-[400]'>
                1360 Shukrawar Peth, Bharat Bhavan, Pune
              </p>
              <p className='opacity-80 py-2 text-green-500 font-[400]'>
                info@arundhatiexim.com
              </p>

              <div>
                <p className='opacity-80 py-3 font-[400]'>Support Center 24/7</p>
                <p>+91 98900 73427</p>
              </div>
            </div>
          </div>

          {/* Form Inputs */}
          <div className='flex flex-col justify-center gap-6 md:pr-12 md:pt-2 pt-12 px-4'>
            <div className='flex gap-4'>
              <div className='flex flex-col gap-6'>
                <input
                  type='text'
                  placeholder='Your Name*'
                  className='border-b bg-transparent font-[300] focus:border-green-500 outline-none transition-all duration-300 ease-in-out p-2'
                  required
                />
                <input
                  type='number'
                  placeholder='Phone Number*'
                  className='border-b bg-transparent  font-[300] focus:border-green-500 outline-none transition-all duration-300 ease-in-out p-2'
                  required
                />
              </div>

              <div className='flex flex-col gap-6'>
                <input
                  type='email'
                  placeholder='Your Email Address*'
                  className='border-b bg-transparent  font-[300] focus:border-green-500 outline-none transition-all duration-300 ease-in-out p-2'
                  required
                />
                <input
                  type='text'
                  placeholder='Subject Name*'
                  className='border-b bg-transparent  font-[300] focus:border-green-500 outline-none transition-all duration-300 ease-in-out p-2'
                  required 
                />
              </div>
            </div>

            <div className='group'>
              <label
                className='border-b bg-transparent  font-[300] focus:border-green-500 outline-none transition-all duration-300 ease-in-out p-2 opacity-45'
                htmlFor='message'
              >
                Your Message*
              </label>
              <textarea
                id='message'
                className='border-b w-full px-4 bg-transparent focus:border-green-500 outline-none transition-all duration-300 ease-in-out p-2'
                required
              ></textarea>
            </div>

            {/* Responsive Submit Button */}
            <Button 
              variant='contained' 
              sx={{ 
                bgcolor: '#22c55e', 
                fontSize: '16px', 
                padding: '10px 20px', 
                width: 'full', 
                '&:hover': {
                  bgcolor: '#16a34a',
                },
              }} 
              className="w-full sm:w-auto sm:px-12 sm:py-3 md:w-auto lg:px-16"
            >
              Submit
            </Button>
          </div>
        </div>

        {/* Google Map Section */}
        <div className='w-full h-[600px] flex justify-center items-center rounded-2xl pt-32'>
          <iframe
            src='https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3783.4241035022014!2d73.85223047496262!3d18.50972748258178!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3bc2c06d994ab465%3A0x2b6ab28034a9a181!2sBharat%20Bhavan!5e0!3m2!1sen!2sin!4v1743358040397!5m2!1sen!2sin'
            width='100%'
            height='600'
            style={{ border: 0 }}
            allowFullScreen
            loading='lazy'
            referrerPolicy='no-referrer-when-downgrade'
            title='Google Map'
          ></iframe>
        </div>
      </div>

      {/* Footer Section */}
      <div className='h-[120px] w-full mt-24 bottom-0 flex justify-evenly flex-col md:flex-row'>
        <div className='flex justify-around flex-1 bg-white flex-col md:flex-row md:gap-0 gap-6'>
          <h2 className='text-4xl uppercase font-bold'>South Global EXIM</h2>
          <div className='text-right md:pb-0 pb-6'>
            <p className='text-xl font-[300]'>Contact Us 24/7</p>
            <p className='text-2xl text-green-500'>+91 98900 73427</p>
          </div>
        </div>
        <div className='bg-green-500 flex justify-center items-center px-12 font-[300] float-right text-white text-3xl'>
          <h3>1360 Shukrawar Peth, Bharat Bhavan, Pune</h3>
        </div>
      </div>
    </>
  );
}
